import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchAccountsTypes = getApiActionTypes('FETCH_ACCOUNTS');
export const fetchAccountGroupsTypes = getApiActionTypes('FETCH_ACCOUNT_GROUPS');
export const fetchAccountDataTypes = getApiActionTypes('FETCH_ACCOUNT_DATA');
export const updateAccountDataTypes = getApiActionTypes('UPDATE_ACCOUNT_DATA');

export const SELECT_ACCOUNT_GROUP = 'SELECT_ACCOUNT_GROUP';
export const SELECT_ACCOUNT = 'SELECT_ACCOUNT';
